import React, { useState } from 'react';
import { EvalModel } from '../../types';

interface ActivateModelDialogProps {
  model: EvalModel;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
}

export const ActivateModelDialog: React.FC<ActivateModelDialogProps> = ({
  model,
  onConfirm,
  onCancel,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const confirm = async () => {
    if (submitting) return;
    setSubmitting(true);
    setError(null);
    try {
      await onConfirm();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to activate model');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1000,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={(e) => {
        if (!submitting && e.target === e.currentTarget) onCancel();
      }}
    >
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--border)',
          borderRadius: 8,
          padding: 24,
          width: 460,
          maxWidth: '90vw',
        }}
      >
        <div
          style={{ fontSize: 15, fontWeight: 600, marginBottom: 8, color: 'var(--text-primary)' }}
        >
          Set default {model.model_type} model
        </div>
        <div
          style={{
            fontSize: 13,
            color: 'var(--text-secondary)',
            marginBottom: 16,
            lineHeight: 1.5,
          }}
        >
          This makes{' '}
          <strong style={{ color: 'var(--text-primary)', fontFamily: 'var(--font-mono)' }}>
            {model.model_name}
          </strong>{' '}
          the default {model.model_type} model — you are changing the default behaviour of Product
          Recognition for every store without an explicit override. Are you sure?
        </div>
        {error && (
          <div style={{ fontSize: 12, color: 'var(--danger)', marginBottom: 12 }}>{error}</div>
        )}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button className="eval-btn-ghost" onClick={onCancel} disabled={submitting}>
            Cancel
          </button>
          <button className="eval-btn" onClick={confirm} disabled={submitting}>
            {submitting ? 'Activating…' : 'Activate'}
          </button>
        </div>
      </div>
    </div>
  );
};
